import React from 'react'
import styled from 'styled-components'
import './animatedShapes.css'

const AnimatedShapes = () => {
  return (
    <div>
      <div className="square"></div>
      <div className="burst"></div>
    </div>
  )
}

export default AnimatedShapes
